import { reactive } from 'vue'
import { Mutation, MutationMitRueckgabe } from './useOfflineQueue'

export const Wochenplanpositionen = reactive([])
let WochenplanungGeladen = false

export async function WochenplanungLaden() {
  if (WochenplanungGeladen) return Wochenplanpositionen
  const Antwort = await fetch('/backend/wochenplanungLaden.php', { credentials: 'include' })
  if (!Antwort.ok) return Wochenplanpositionen
  const Daten = await Antwort.json()
  Wochenplanpositionen.splice(0, Wochenplanpositionen.length, ...Daten)
  WochenplanungGeladen = true
  return Wochenplanpositionen
}

export async function WochenplanpositionSpeichern(Datum, Kategorie, RezeptId, Personen = null) {
  const Daten = await MutationMitRueckgabe('/backend/wochenplanpositionSpeichern.php', { Datum, Kategorie, RezeptId, Personen })
  const Index = Wochenplanpositionen.findIndex(p => p.Datum === Datum && p.Kategorie === Kategorie)
  if (Index !== -1) {
    Object.assign(Wochenplanpositionen[Index], Daten)
  } else {
    Wochenplanpositionen.push(Daten)
  }
  return Daten
}

export async function WochenplanpositionLoeschen(Id) {
  const Index = Wochenplanpositionen.findIndex(p => p.Id === Id)
  const Sicherung = Index !== -1 ? { ...Wochenplanpositionen[Index] } : null
  await Mutation(
    '/backend/wochenplanpositionLoeschen.php',
    { Id },
    () => { if (Index !== -1) Wochenplanpositionen.splice(Index, 1) },
    () => { if (Sicherung !== null) Wochenplanpositionen.splice(Index, 0, Sicherung) }
  )
}
